import axios from '../axios'
import { UserRequest } from '../helpers/types/userRequest'

export const findPending = async (id: number) => {
	const { data } = await axios.get(`/api/v1/user-request/${id}`)
	return data
}

export const permitRegistration = async (body: {
	decision: 'ALLOWED' | 'REJECTED'
	telegramId: number
}) => {
	const { data } = await axios.post(
		`/api/v1/user-request/permit`,
		body
	)
	return data
}

export const createRegisterRequest: (
	body: Partial<UserRequest>
) => Promise<UserRequest> = async (body) => {
	const { data } = await axios.post(
		'/api/v1/user-request/register',
		body
	)
	return data
}

export const findByTelegramId = async (telegramId: number) => {
	const { data } = await axios.get(
		`/api/v1/user-request/find/register/${telegramId}`
	)
	return data
}
